import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = {
  class: "form fv-plugins-bootstrap5 fv-plugins-framework",
  id: "kt_modal_add_event_form"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, "Send email template", -1)
const _hoisted_5 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_6 = { class: "modal-footer flex-center" }
const _hoisted_7 = {
  "data-bs-dismiss": "modal",
  type: "reset",
  id: "kt_modal_add_event_cancel",
  class: "btn btn-light me-3"
}
const _hoisted_8 = ["data-kt-indicator", "onClick"]
const _hoisted_9 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_10 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_11 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

import { ref } from "vue";
import { hideModal, showModal } from "@/core/helpers/dom";
import GlobalService from "../../../services/TenantGlobalService";


export default /*#__PURE__*/_defineComponent({
  __name: 'SendTestEmail',
  setup(__props, { expose: __expose }) {

const emailAddress = ref("");
const emailTitle = ref("");
const emailLang = ref("");
const isLoading = ref(true);
const sendEmailModalRef = ref("sendEmailModalRef");

const show = async (title, lang) => {
  emailTitle.value = title;
  emailLang.value = lang;
  showModal(sendEmailModalRef.value);
  isLoading.value = false;
};

const hide = () => {
  hideModal(sendEmailModalRef.value);
};

const submit = async () => {
  isLoading.value = true;
  let data = {
    to: emailAddress.value,
    title: emailTitle.value,
    language: emailLang.value,
  };
  await GlobalService.sendEmailTemplate(data);
  isLoading.value = false;
};

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    tabindex: "9999",
    "aria-hidden": "true",
    "aria-modal": "true",
    role: "dialog",
    ref_key: "sendEmailModalRef",
    ref: sendEmailModalRef,
    style: {"z-index":"9999 !important"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.email'),
              prop: "email"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: emailAddress.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((emailAddress).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.$t("status.cancel")), 1),
            _createElementVNode("button", {
              "data-kt-indicator": isLoading.value ? 'on' : null,
              class: "btn btn-lg btn-primary",
              onClick: _withModifiers(submit, ["prevent"]),
              type: "button"
            }, [
              (!isLoading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.submit")) + " ", 1),
                    _createElementVNode("span", _hoisted_10, [
                      _createVNode(_component_inline_svg, { src: "/images/icons/arrows/arr064.svg" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                    _createTextVNode(_toDisplayString(_ctx.$t("title.inProgress")) + " ", 1),
                    _hoisted_12
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_8)
          ])
        ])
      ])
    ])
  ], 512))
}
}

})